// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2czGX","padded":"styles_padded__2xlU4"};